<template>
  <div class="wrapper page-klk-container dkt">
    <div class="container">
      <Banner desc="“我是接班人 学习新思想”全省首堂中小学《习近平新时代中国特色社会主义思想学生读本》思政专题课由中共湖南省委宣传部指导，湖南省教育厅、湖南广播电视台主办，芒果TV承办，长沙市芙蓉区教育局联合制作，按照思政教育特点和教学规律为中小学生量身订制，共42集，分为小学低年级、小学高年级、初中三大板块，于4月8日晚8点起在湖南省“互联网+教育”大平台、芒果大电视 “快乐看”频道同步上线播出，后续每周（或隔周）五晚8点更新。" :bannerInfo="bannerInfo" @play="onPlayClick"></Banner>
      <Character v-if="characterList.length" :character-list="characterList"></Character>
      <Topic :page-name="'xzs'" :topic-list="topicList" @play="onPlayClick"></Topic>
    </div>
    <div class="footer-bg"></div>
  </div>
</template>
<script>
import Banner from '@/components/banner.vue'
import Character from '@/components/character.vue'
import Topic from '@/components/topic'
import axios from '@/utils/request'
import jumpPage from '@/utils/utils'

export default {
  components: {
    Banner,
    Character,
    Topic
  },
  data () {
    return {
      // vclassId: (false ? 1431904 : 742937),
      vclassId: (process.env.NODE_ENV === 'production' ? 1431904 : 742937),
      bannerInfo: {
        videoList: []
      },
      characterList: [],
      topicList: []
    }
  },
  mounted () {
    console.log('NODE_ENV', process.env.NODE_ENV)
    this.getData()
    document.body.setAttribute('mg-stat-page', 'klk_headmasterSaid')
    window.MgStat.send('pv', {}, {src: 'klk'}) // 手动发送PV
  },
  methods: {
    getData () {
      axios.get(`${this.serverUrl}/home/cms/list?vclassId=${this.vclassId}`).then(res => {
        const moduleData = res.data.moduleList
        let topicList = []
        moduleData.map(item => {
          if (item.ottModuleType === 'web_banner') {
            this.bannerInfo.videoList = item.videoList
          } else if (item.ottModuleType === 'character_module') {
            this.characterList = item.videoList
          } else if (item.ottModuleType === 'topic_module') {
            topicList.push({videoList: item.videoList, moduleTitle: item.moduleTitle, caseId: item.caseId})
          }
        })
        this.topicList = topicList
      })
    },
    onPlayClick: function (video) {
      let url = jumpPage(video)
      window.open(`${this.videoPlayUrl}${url}`, '_blank')
      // const vid = video.jumpDefaultParam[0].value
      // // modal.player && modal.player.fetchVideoInfo(vid);
      // // modal.qrCode = getKlkUrl(video);
      // // jumpID是3605就是学习计划，3602是单视频
      // const isPlan = video.jumpId == 3605
      // window.open(window.location.origin + window.location.pathname + `#/video?type=${isPlan?'plan':'video'}&id=${vid}&cxid=${isPlan?'1s6lhj7va':'2fvxf8uus'}`, '_blank');
    }
  }
}
</script>
<style scoped>
  .page-klk-container {
    background-image: url("./images/xzs-top-jbr.jpg");
    background-repeat: no-repeat;
    background-color: #ce393f;
  }
  .footer-bg {
    height: 362px;
    background: url("./images/xzs-bottom-jbr.jpg")no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xzs.vue